const HoldingCustomersManager = () => import('@/modules/Holding/CustomersManager')

export default [
	{
		component: HoldingCustomersManager,
		name: 'holding-customers',
		path: 'customers'
	}
]